import { useState } from "react";
import { MessageSquareText } from "lucide-react";
import WhatsAppIcon from "../ui/WhatsAppIcon";
import api from "../../api";

// Platform-wide on/off for one channel (backend notifications/messaging_switches.py):
// SMS at the top of Platform admin -> SMS templates, WhatsApp at the top of
// WhatsApp templates. Which channel a message tries first is on its own page,
// Platform admin -> Message Channels (pages/admin/AdminMessageChannels.js).
const CHANNELS = [
  { key: "sms", label: "SMS", icon: <MessageSquareText className="w-5 h-5 text-secondary-600" />, off: "No SMS goes out for anyone: login codes, patient alerts, crisis alerts, subscription messages." },
  { key: "whatsapp", label: "WhatsApp", icon: <WhatsAppIcon size={20} brand />, off: "No WhatsApp message goes out, except the automatic safety reply to someone who writes to the number." },
];

export default function MessagingSwitches({ channel, switches, onChange }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const c = CHANNELS.find((x) => x.key === channel);
  if (!c) return null;
  const on = !!switches?.[c.key];

  const toggle = async (enabled) => {
    if (!enabled && !window.confirm(`Switch ${c.label} off for the whole platform?`)) return;
    setBusy(true);
    setMsg(null);
    try {
      const r = await api.saveMessagingSwitch(c.key, enabled);
      onChange(r.data.switches);
    } catch (e) {
      setMsg(e?.response?.data?.error || "Couldn't save.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="rounded-xl border border-secondary-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-secondary-900">{c.label} for the whole platform</h2>
        <p className="text-sm text-secondary-500 mt-1">
          Master switch. Underneath it, each template below, each clinic's channels and each clinic's alert settings
          still apply. In-app and email alerts aren't affected. Which channel a message tries first is set
          under Message Channels.
        </p>
      </div>
      <label className={`flex items-start gap-3 rounded-lg border p-3 normal-case font-sans tracking-normal cursor-pointer ${on ? "border-emerald-300 bg-emerald-50" : "border-secondary-200 bg-secondary-50"}`}>
        <input type="checkbox" className="mt-1 h-4 w-4" checked={on} disabled={busy}
          onChange={(e) => toggle(e.target.checked)} />
        <span>
          <span className="flex items-center gap-2 text-sm font-semibold text-secondary-900">{c.icon} {c.label}: {on ? "On" : "Off"}</span>
          {!on && <span className="block text-xs text-secondary-600 mt-0.5">{c.off}</span>}
        </span>
      </label>
      {msg && <p className="text-sm text-red-600">{msg}</p>}
    </section>
  );
}
